function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { nl } from 'date-fns/locale';
import * as React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { Block } from "../../../custom_components/components/library/container";
import { Link } from "../../../custom_components/components/library/link";
import { trackNewsletterSubscription } from "../../../custom_components/components/library/tracking";
import { Loader } from "../../../custom_components/components/loader";
import { submitForm } from "./newsletterFormBlockApi";
import { allFields, initialBirthDate, initialState, newsletterLabel, newsletterName, newslettersId, setFieldOnState, setVisited, toggleNewsletterOnState, validateFields, validateFormData } from "./newsletterFormBlockState";
const debounce = require("lodash.debounce");
registerLocale('nl', nl);
export class NewsletterForm extends React.Component {
    submit() {
        const validationMessages = validateFields(allFields, this.state.data);
        if (validationMessages.count() > 0) {
            this.setState((prevState)=>({
                    ...prevState,
                    validationMessages
                }));
            return;
        }
        this.setState((prevState)=>({
                ...prevState,
                status: 'submitting'
            }), async ()=>{
            const status = await submitForm(this.state.data) ? 'succeeded' : 'failed';
            if (status == 'succeeded') trackNewsletterSubscription();
            this.setState((prevState)=>({
                    ...prevState,
                    status
                }));
        });
    }
    maybeShowMessage(field) {
        const messages = this.state.validationMessages;
        return messages.has(field) ? /*#__PURE__*/ _jsx("p", {
            className: "form__description form__error",
            children: messages.get(field)
        }) : /*#__PURE__*/ _jsx(_Fragment, {});
    }
    render() {
        if (this.state.status == 'submitting') return submitting;
        if (this.state.status == 'succeeded') return succeeded;
        if (this.state.status == 'failed') return failed;
        const setField = setFieldOnState(this.setState.bind(this));
        const set = (field)=>(e)=>{
                setField(field)(e.target.value);
                this.validateVisitedAfterDelay();
            };
        const toggler = toggleNewsletterOnState(this.setState.bind(this));
        const toggleNewsletter = (newsletter)=>{
            toggler(newsletter);
            this.validateVisitedAfterDelay();
        };
        const setVisit = setVisited(this.setState.bind(this));
        const visit = (field)=>()=>setVisit(field);
        const { firstName, lastName, emailAddress, birthDate, newsletters: selectedNewsletters } = this.state.data;
        const canSubmit = this.state.validationMessages.size == 0;
        return /*#__PURE__*/ _jsx(Block, {
            children: /*#__PURE__*/ _jsx("div", {
                className: "newsletter-form container--sg align--center",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "align--center",
                    children: [
                        /*#__PURE__*/ _jsxs("fieldset", {
                            children: [
                                /*#__PURE__*/ _jsx("legend", {
                                    className: "form__title title--l container--xs",
                                    children: "Persoonlijke informatie"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "container--s",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "form__group form__group--name",
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "form__field",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("label", {
                                                            className: "form__label search__label form__label--required",
                                                            htmlFor: "emailAddress",
                                                            children: "E-mailadres"
                                                        }),
                                                        /*#__PURE__*/ _jsx("input", {
                                                            className: "form__input",
                                                            name: "emailAddress",
                                                            type: "email",
                                                            onFocus: visit('emailAddress'),
                                                            onChange: set('emailAddress'),
                                                            value: emailAddress
                                                        }),
                                                        this.maybeShowMessage('emailAddress')
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "form__field form__field--long",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("label", {
                                                            className: "form__label search__label",
                                                            htmlFor: "firstName",
                                                            children: "Voornaam"
                                                        }),
                                                        /*#__PURE__*/ _jsx("input", {
                                                            className: "form__input",
                                                            name: "firstName",
                                                            type: "text",
                                                            onFocus: visit('firstName'),
                                                            onChange: set('firstName'),
                                                            value: firstName
                                                        }),
                                                        this.maybeShowMessage('firstName')
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "form__field form__field--long",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("label", {
                                                            className: "form__label search__label form__label--required",
                                                            htmlFor: "lastName",
                                                            children: "Achternaam"
                                                        }),
                                                        /*#__PURE__*/ _jsx("input", {
                                                            className: "form__input",
                                                            name: "lastName",
                                                            type: "text",
                                                            onFocus: visit('lastName'),
                                                            onChange: set('lastName'),
                                                            value: lastName
                                                        }),
                                                        this.maybeShowMessage('lastName')
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "form__field",
                                            children: [
                                                /*#__PURE__*/ _jsx("label", {
                                                    className: "form__label search__label",
                                                    htmlFor: "birthDate",
                                                    children: "Geboortedatum"
                                                }),
                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                    openToDate: initialBirthDate,
                                                    locale: "nl",
                                                    dateFormat: "dd MMMM yyyy",
                                                    selected: birthDate,
                                                    onFocus: visit('birthDate'),
                                                    onChange: (newDate)=>setField('birthDate')(newDate),
                                                    filterDate: (date)=>date.getTime() < Date.now(),
                                                    showYearDropdown: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "form__field",
                                            children: [
                                                /*#__PURE__*/ _jsx("label", {
                                                    className: "form__label search__label form__label--required",
                                                    children: "Ik wil me inschrijven voor de"
                                                }),
                                                newslettersId.map((newsletter)=>/*#__PURE__*/ _jsxs("div", {
                                                        className: "form__checkbox",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("input", {
                                                                className: "form__input--checkbox",
                                                                type: "checkbox",
                                                                name: newsletterName[newsletter],
                                                                value: newsletterName[newsletter],
                                                                checked: selectedNewsletters.includes(newsletter),
                                                                onChange: ()=>toggleNewsletter(newsletter)
                                                            }),
                                                            /*#__PURE__*/ _jsx("label", {
                                                                className: "form__label--checkbox",
                                                                htmlFor: "nieuwsLetter",
                                                                onClick: ()=>toggleNewsletter(newsletter),
                                                                children: newsletterName[newsletter]
                                                            }),
                                                            /*#__PURE__*/ _jsx("p", {
                                                                className: "form__description",
                                                                children: newsletterLabel[newsletter]
                                                            })
                                                        ]
                                                    }, newsletterName[newsletter])),
                                                this.maybeShowMessage('newsletters')
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            className: "button button--primary",
                            disabled: !canSubmit,
                            onMouseOver: ()=>this.validate(true),
                            onClick: ()=>this.submit(),
                            children: "Verstuur"
                        })
                    ]
                })
            })
        });
    }
    constructor(props){
        super(props), _define_property(this, "validate", validateFormData(this.setState.bind(this))), _define_property(this, "validateVisitedAfterDelay", debounce(()=>this.validate(), 1000));
        this.state = initialState;
    }
}
const submitting = /*#__PURE__*/ _jsx(Block, {
    children: /*#__PURE__*/ _jsx("div", {
        className: "newsletter-form newsletter-form--submitting container--lg align--center",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container--m align--center",
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "form__title title--l container--xs",
                    children: "Bezig met versturen"
                }),
                /*#__PURE__*/ _jsx(Loader, {})
            ]
        })
    })
});
const succeeded = /*#__PURE__*/ _jsx(Block, {
    children: /*#__PURE__*/ _jsx("div", {
        className: "newsletter-form newsletter-form--succeeded container--lg align--center",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container--m align--center",
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "form__title title--l container--xs",
                    children: "Inschrijving verstuurd"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "container--s text--styled",
                    children: /*#__PURE__*/ _jsx("p", {
                        children: "Bedankt voor het aanmelden voor de nieuwsbrief! We hebben je gegevens verwerkt zodat je de nieuwsbrief binnenkort ontvangt."
                    })
                })
            ]
        })
    })
});
const failed = /*#__PURE__*/ _jsx(Block, {
    children: /*#__PURE__*/ _jsx("div", {
        className: "newsletter-form newsletter-form--failed container--lg align--center",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container--m align--center",
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "form__title title--l container--xs",
                    children: "Het inschrijven is mislukt"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "container--s text--styled",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            children: "Er is iets misgegaan tijdens het aanmelden voor de nieuwsbrief. Herlaadt deze pagina en probeer het nog eens."
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            children: [
                                "Lukt het nog steeds niet? Neem dan ",
                                /*#__PURE__*/ _jsx(Link, {
                                    url: "/klantenservice",
                                    children: "contact"
                                }),
                                " met ons op."
                            ]
                        })
                    ]
                })
            ]
        })
    })
});
